module.exports = __webpack_public_path__ + "img/users.f01ae729.svg";